import React, { useEffect, useState } from 'react'

interface TypingAnimationProps {
  lang?: 'JA' | 'EN';
}

const TypingAnimation: React.FC<TypingAnimationProps> = ({ lang = 'JA' }) => {
  const [anistate, setAnistate] = useState(0)

  useEffect(() => {
    const interval1 = setInterval(() => {
      setAnistate(n => n === 3 ? 0 : n + 1)
    }, 500)
    return () => {
      clearInterval(interval1)
    }
  }, [])

  const typingText = lang === 'JA' ? '１F８さんはタイプしています' : '1F8 is typing'

  return (
    <div className='flex items-center space-x-2'>
      <span className='mr-1'>{typingText}</span>
      {anistate > 0 && <div className='w-2 h-2 rounded-full bg-gradient-to-r from-gray-400 to-gray-600 animate-pulse'></div>}
      {anistate > 1 && <div className='w-2 h-2 rounded-full bg-gradient-to-r from-gray-400 to-gray-600 animate-pulse delay-75'></div>}
      {anistate > 2 && <div className='w-2 h-2 rounded-full bg-gradient-to-r from-gray-400 to-gray-600 animate-pulse delay-150'></div>}
    </div>
  )
}

export default TypingAnimation